export default __webpack_public_path__ + "static/media/student-hat.707559ac.png";